/*
  UI copy (English).

  Every key here has a matching key in zh.js — a missing one shows up on the page
  as the key itself. Written the way an English-speaking crypto user would say it,
  not as a word-for-word translation of the Chinese file. SEO copy lives in
  src/seo/content.mjs.
*/
export default {
  home: {
    /* ---------------------------- Top bar / page head ---------------------------- */
    wallet: 'Connect wallet',
    langLabel: 'Switch language',
    MultiSender: 'Send to many',
    currentChain: 'Network',
    notConnected: 'Wallet not connected',
    chainUnknown: 'Network not recognized',
    chainIdLabel: 'Chain ID',
    nativeCoin: 'native coin',
    unlistedChainHint:
      'This chain ID is not in the price list, so the fee falls back to 1 native coin. If you are actually on a common chain such as Polygon or BNB Chain, your wallet is probably pointing at a custom RPC whose network ID does not match the chain ID — switching back to the official RPC fixes it.',

    /* ---------------------------- Page head / what this page can do ---------------------------- */
    anyChainTitle: 'Create a Token on Any EVM Chain',
    anyChainLead:
      'Deploy a token on whatever EVM-compatible chain your wallet is connected to. Your wallet deploys the contract directly, with no factory contract in between, so new and niche chains work too.',
    anyChainCan: 'What you can do here',
    anyChainCan1: 'Deploy a token and get its contract address instantly',
    anyChainCan2: 'Add liquidity and trade on that chain’s DEX',
    anyChainCant1:
      'Vanity addresses — not available here; they require a factory contract',
    anyChainCant2:
      'Token management, volume bots and locks — not available here; use the main site on a supported chain',
    anyChainFeeNote:
      'The deployment fee is sent as the transaction value. The token constructor forwards it to our fee address in the same transaction, so deploying and paying happen together.',
    anyChainTip:
      'Need the full toolkit, including vanity addresses, token management and a volume bot? Use the main site and launch on a supported chain.',

    /* ---------------------------- Create token ---------------------------- */
    chuangjian: 'Create token',
    creating: 'Deploying…',
    moshi: 'Token mode',
    biaozhun: 'Standard token',
    biaozhunTip: 'Name, symbol, decimals, supply, owner',
    shouxufei: 'Tax token',
    shouxufeiTip: 'A standard token with marketing and burn fees plus a marketing wallet',

    quancheng: 'Token name',
    quancheng1: 'e.g. Tesla',
    jiancheng: 'Token symbol',
    jiancheng1: 'e.g. TSLA',
    jingdu: 'Decimals',
    zongliang: 'Total supply',
    guanli: 'Owner address',
    admdizhi: 'Enter the owner address',
    yingxiao: 'Marketing fee (%)',
    ranshao: 'Burn fee (%)',
    yingxiaodizhi: 'Marketing wallet',
    yingxiaodizhiPh: 'Enter the marketing wallet address',

    /* ---------------------------- Source & params ---------------------------- */
    kaiyuan: 'Source and constructor parameters',
    yuandaima: 'Copy contract source',
    canshu: 'Copy constructor parameters',

    /* ---------------------------- Token tools ---------------------------- */
    toolsTitle: 'Token tools',
    toolsLead: 'Enter a token address to renounce ownership of the contract.',
    tokenAddr: 'Token address',
    daibidizhi: 'Enter the token contract address',
    toolAddrHint: 'This is the token contract the tool will operate on.',
    fangqi: 'Renounce ownership',
    queding: 'Confirm',
    toolFangqiHint:
      'Transfers ownership to the dead address (0x…dEaD). Once you do, no one — including you — can change the token settings, and it cannot be undone.',

    /* ---------------------------- Footer / support ---------------------------- */
    footerBlurb:
      'Multi-chain token creation, airdrops, liquidity locks and on-chain management tools, ready to use with your wallet.',
    contactTitle: 'Community and support',
    footerDisclaimer:
      'This tool is intended for blockchain testing and educational use only. It is not intended for users in mainland China. We are not responsible for unlawful use.',
    supportTitle: 'Support GTokenTool',
    kafei: 'Buy me a coffee',
    qrAlt: 'Donation QR code for GTokenTool',
    copyAddr: 'Copy address',

    /* ---------------------------- Action feedback ---------------------------- */
    copyOk: 'Copied',
    errUnknown: 'Unknown error',
    needWallet: 'Connect your wallet first',
    badTokenAddr: 'That does not look like a valid token address',
    enterTokenAddr: 'Enter the token address',
    lowBalance: 'Not enough balance to cover the fee',
    contractAddr: 'Contract address: {addr}',
    contractLive: 'Contract is live on-chain',
    txCancelled: 'Transaction canceled',
    deployFail: 'Deployment failed: {msg}',
    renounceOk: 'Ownership renounced',
    renounceFail: 'Could not renounce ownership: {msg}',

    /* ---------------------------- Form validation ---------------------------- */
    vName: 'Enter the token name',
    vSymbol: 'Enter the token symbol',
    vDecimals: 'Decimals must be a whole number between 0 and 255',
    vSupply: 'Enter the total supply as a whole number above 0',
    vAdmin: 'That owner address is not a valid wallet address',
    vMarkFee: 'Marketing fee must be a whole number from 0 to 100 (percent)',
    vBurnFee: 'Burn fee must be a whole number from 0 to 100 (percent)',
    vMarkWallet: 'That marketing wallet is not a valid wallet address',
  },
}
